import { Link } from '@/common/components/Link';
import { styled, useTheme } from '@mui/material';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        margin: 0 auto;
        font-weight: ${theme.typography.fontWeightBold};
        padding: ${theme.spacing(0, 1, 0, 0)};
        
        @media (max-width: ${theme.breakpoints.values.sm}px) {
          padding: ${theme.spacing(0, 0.5)};
        }
        
        @media (max-width: 280px) {
          padding: ${theme.spacing(0, 0.25)};
        }

        -webkit-user-drag: none;
        user-drag: none;
`
);

export const Logo = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <LogoWrapper href="/templates">
      <img
        src={
          isDark
            ? '/logo-creative-studio.svg'
            : '/logo-creative-studio-light-mode.svg'
        }
        alt="Guud TV"
        width={160}
        draggable={false}
      />
    </LogoWrapper>
  );
};
